import React, { FC } from 'react';
import { SvgIcon } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IAMNSVGProps } from './AMNIcon';
import { colorToFill } from './colorUtils';

export const TaskIcon: FC<IAMNSVGProps> = props => {
  const { color, ...restProps } = props;
  const theme = useTheme();
  const fill = colorToFill(color, theme);

  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.117 22.197" htmlColor={fill} {...restProps}>
      <path
        d="M26.083,43.8,22,33.065a2.579,2.579,0,0,0-2.416-1.7H6.53a2.579,2.579,0,0,0-2.416,1.7L.034,43.8A.554.554,0,0,0,0,44.033v6.888a2.644,2.644,0,0,0,2.611,2.644H23.5a2.644,2.644,0,0,0,2.611-2.644V44.033A.555.555,0,0,0,26.083,43.8ZM5.322,33.522a1.338,1.338,0,0,1,1.208-.849H19.588a1.338,1.338,0,0,1,1.208.849l3.754,9.923h-3V39.039c0-.359-.261-.49-.62-.49H19.588V35.122c0-.359-.261-.49-.62-.49H7.15c-.359,0-.62.131-.62.49v3.428H5.518c-.359,0-.62.131-.62.49v4.407H1.568Zm12.992,6.333H20.24v3.591H17.433a.653.653,0,0,0-.653.522,3.783,3.783,0,0,1-7.443,0,.653.653,0,0,0-.653-.522H6.2V39.855ZM7.836,38.549V35.938H18.282v2.611ZM24.81,50.921A1.338,1.338,0,0,1,23.5,52.26H2.613a1.338,1.338,0,0,1-1.306-1.338v-6.17H8.2a5.076,5.076,0,0,0,9.728,0H24.81v6.17Z"
        transform="translate(0 -31.368)"
      />
    </SvgIcon>
  );
};
